import { CartItem } from '~/features/cart/cart-item.interface'
import { GQLCartItemInput } from '~/types/gql'

export const cartItemInputMapper = (cartItem: CartItem): GQLCartItemInput => {
  return {
    id: cartItem.product.ID,
    quantity: cartItem.qty,
  }
}
